// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2VxiN","col":"styles_col__MrbX5"};